import React from 'react';
import PropTypes from 'prop-types';

import useFormContext from 'dpl/shared/form/hooks/useFormContext';

import SimpleTelephoneInput from './SimpleTelephoneInput';

export default function TelephoneInput({
  name,
  onChange,
  ...inputProps
}) {
  const {
    formFieldErrors,
    formFieldId,
    formFieldValue,
    addToFormState
  } = useFormContext(name);

  function handleChange(value) {
    addToFormState(name, value);
  }

  return (
    <SimpleTelephoneInput
      errors={ formFieldErrors }
      id={ formFieldId }
      name={ name }
      onChange={ onChange || handleChange }
      value={ formFieldValue }
      { ...inputProps }
    />
  );
}

TelephoneInput.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func
};

TelephoneInput.defaultProps = {
  onChange: null
};
